import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7fc9b18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notifications" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "bell-notification" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "p-p-2"
}
const _hoisted_5 = {
  key: 0,
  class: "p-d-flex p-jc-end p-px-2 p-py-0 bg-gray notification-header"
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 2,
  class: "p-p-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_placeholder_state = _resolveComponent("placeholder-state")!
  const _component_Button = _resolveComponent("Button")!
  const _component_notification = _resolveComponent("notification")!
  const _component_card_placeholder = _resolveComponent("card-placeholder")!
  const _component_custom_transition = _resolveComponent("custom-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "lottie__bell",
      onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.animHoverIn && _ctx.animHoverIn(...args))),
      onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.animHoverOut && _ctx.animHoverOut(...args))),
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleNotificationPanel && _ctx.toggleNotificationPanel(...args)))
    }, _hoisted_3, 32),
    _createVNode(_component_custom_transition, { duration: { enter: 150, leave: 150 } }, {
      default: _withCtx(() => [
        (_ctx.showNotificationPanel)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(['notifications-panel', _ctx.localNotifications.length > 0 ? 'scroll' : '']),
              ref: "notificationPanelRef"
            }, [
              (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_placeholder_state, { isComponentError: "" })
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.localNotifications.length > 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createVNode(_component_Button, {
                            class: "tertiary p3",
                            onClick: _ctx.markAsReadAllNotifications
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.copies.marcAllAsReaded), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.localNotifications.length > 0)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localNotifications, (n) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: n._id
                            }, [
                              _createVNode(_component_notification, {
                                tag: n.tag,
                                text: n.text,
                                createdAt: n.createdAt,
                                onOnClick: _ctx.handleClick,
                                id: n._id,
                                wasRead: n.flags.wasReaded
                              }, null, 8, ["tag", "text", "createdAt", "onOnClick", "id", "wasRead"])
                            ]))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createVNode(_component_card_placeholder, {
                            message: _ctx.copies.noNotifications
                          }, null, 8, ["message"])
                        ]))
                  ], 64))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}